import React, { useCallback, useState } from 'react'
import { Radio, RadioGroup } from 'components/FormElements/RadioGroup/RadioGroup'
import { VisitCancelReason } from 'api/api.types'
import { Modal } from 'components/Utility/Modal/Modal'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import styles from './Modals.module.scss'

export type CancelForm = {
  reason: VisitCancelReason,
  comment: string,
}

const REASONS: Array<[VisitCancelReason, string]> = [
  [VisitCancelReason.error, 'Записались по ошибке.'],
  [VisitCancelReason.anotherTime, 'Не успеваю, буду записываться на другое время.'],
  [VisitCancelReason.anotherSalon, 'Воспользуюсь услугами другого салона.'],
  [VisitCancelReason.other, 'Другая причина.'],
]

const Field: React.FC<{ value: VisitCancelReason, title: string }> = ({ value, title }) => {
  const id = `cancel-reason-${value}`
  // Clicking the input itself works around fastclick swallowing label clicks
  return <label className={styles.field} htmlFor={id} onClick={() => document.getElementById(id)?.click()}>
    <Radio className={styles.cancelModalRadio} value={value} id={id} />
    <span className={styles.cancelModalCheckmark} />
    <span className={styles.cancelModalRadioTitle}>{title}</span>
  </label>
}

type CancelModalProps = {
  isOpen?: boolean,
  submitting?: boolean,
  onClose: () => void,
  onSubmit: (form: CancelForm) => Promise<void>,
}

/** Asks why the client cancels a visit */
export const CancelModal: React.FC<CancelModalProps> = (props) => {
  const { isOpen = false, submitting = false, onClose, onSubmit } = props
  const [reason, setReason] = useState(VisitCancelReason.error)
  const [comment, setComment] = useState('')

  const handleSubmit = useCallback(async () => {
    await onSubmit({ reason, comment })
    setReason(VisitCancelReason.error)
    setComment('')
  }, [onSubmit, reason, comment])

  return (
    <Modal
      isOpen={isOpen}
      className={styles.container}
      title={'Выберите, пожалуйста, причину отмены записи'}
      onClose={onClose}
    >
      <RadioGroup
        className={styles.fieldsContainer}
        selectedValue={reason}
        onChange={setReason}
        name={'reason'}
      >
        {REASONS.map(([value, title]) => <Field key={value} value={value} title={title} />)}
        <div className={styles.field}>
          <textarea
            className={styles.textarea}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder={'Комментарий'}
          />
        </div>
        <AppButton disabled={submitting} onClick={handleSubmit} className={styles.button}>
          Отменить
        </AppButton>
      </RadioGroup>
    </Modal>
  )
}
